import { getRouteParams } from './getRouteParams';
export const getIntentKey = () => {
  return getRouteParams().intentKey;
};